import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Center } from "../../../../../../Components/Utils/Center";


export class TableEntry extends Div
{
    private warningBox = new Div("warning").BorderTop(1, "#aaa", "solid");

    constructor(input: { Content: appendable[]; Warning?: appendable[]; })
    {
        super("entry");

        this.Append(
            new Div().Append(...input.Content).FontSize(12),
            input.Warning && input.Warning.length > 0 && new Center(
                this.warningBox.Append(...input.Warning)
            )
        );
    }
}

export class TableEntryV2 extends Div
{
    private infoBox = new Div("warning").BorderTop(1, "#ccc", "dashed").FontSize(11)

    constructor(input: { Content: appendable[]; ExtraInfo?: appendable[]; })
    {
        super("entry");

        this.Append(
            new Div().Append(...input.Content),
            input.ExtraInfo && input.ExtraInfo.length > 0 && new Center(
                this.infoBox.Append(...input.ExtraInfo)
            )
        );
    }
}
